import React from "react";

function Stats() {
    return (
        <div className="bg-dj-dark md:p-20 py-12 px-8">
            <div className="max-w-6xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
                    <div className="space-y-2">
                        <h3 className="text-4xl md:text-5xl font-bold text-primary">15+</h3>
                        <p className="text-lg text-white">Years of Experience</p>
                    </div>
                    <div className="space-y-2">
                        <h3 className="text-4xl md:text-5xl font-bold text-primary">50+</h3>
                        <p className="text-lg text-white">Projects Delivered</p>
                    </div>
                    <div className="space-y-2">
                        <h3 className="text-4xl md:text-5xl font-bold text-primary">100%</h3>
                        <p className="text-lg text-white">Client Satisfaction</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Stats;
